import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Emitir Etiquetas',
    path: '/gestao/etiquetas/emissao',
    name: 'gestao_etiquetas_emissao',
    component: () => import('@/views/gestao/etiqueta/Emissao.vue'),
    meta: { permissions: [eTipoPermissao.BIB_ETIQUETANOVO_MENU_1300500199] },
    goesToMenu: true,
  },
  {
    description: 'Configuração de Etiquetas',
    path: '/gestao/etiquetas',
    name: 'gestao_etiquetas',
    component: () => import('@/views/gestao/etiqueta/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.BIB_CONFIGURARETIQUETASNOVO_MENU_1300500198],
    },
    goesToMenu: true,
  },
];

